import { restrictToWindowEdges } from '@dnd-kit/modifiers'
import { colors } from '@fs/zion-ui'
import React from 'react'
import { createPortal } from 'react-dom'
import { useTranslation } from 'react-i18next'
import { useWatch } from '@fs/zion-form'
import { DragOverlay as DndDragOverlay } from '@dnd-kit/core'
import { css } from '@emotion/core'
import { BaseDraggablePersonDisplay } from './DraggablePerson'

const personsStackContainerCss = css`
  position: relative;
  width: 100%;
  min-height: 3.25rem; // Same height as a normal ListItem to ensure dnd kit can detect collisions
`

const personsStackCss = css`
  position: absolute;
  box-shadow: 0 0 0.3125rem rgb(68 68 68 / 0.6);
  background: ${colors.white100};
  border-radius: 0.25rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: min-content;
  width: 100%;
`

const DragOverlay = () => {
  const [t] = useTranslation()
  const [dragInfo, selectedPersonsIds] = useWatch({
    name: ['dragInfo', 'selectedPersonsIds'],
  })

  return createPortal(
    <DndDragOverlay modifiers={[restrictToWindowEdges]} dropAnimation={null}>
      <div css={personsStackContainerCss} data-testid="drag-overlay-container">
        {selectedPersonsIds.slice(0, 3).map((personId, index) => (
          <div
            key={personId}
            css={personsStackCss}
            // Style the overlay to stack the dragged persons
            style={{
              top: `${index * 5}px`,
              insetInlineStart: `${index * 5}px`,
              zIndex: (index + 1) * -1,
            }}
          >
            <BaseDraggablePersonDisplay
              person={dragInfo?.person}
              t={t}
              key={dragInfo?.person?.id}
              record={dragInfo?.record}
            />
          </div>
        ))}
      </div>
    </DndDragOverlay>,
    document.body
  )
}

export default DragOverlay
